import rewardSVG from 'assets/icons/rewards.svg'
import close from 'assets/icons/close-white.svg'
import { useAppSelector } from 'state/hooks'
import { hideBoostBanner, selectShowBoostBanner } from 'state/slices/ui/dash'

export function BoostBanner() {
  const show = useAppSelector(selectShowBoostBanner)
  if (!show) return null
  return (
    <div className="reward-banner">
      <div className="reward-banner__left">
        <img src={rewardSVG} alt="reward" />
        <div className="reward-banner__content">
          <h3>Stablecoin rewards boost!</h3>
          <p>On April 10th, 2026 the rewards for USDCx and USDT.e were increased. Enjoy!</p>
        </div>
      </div>
      <img src={close} alt="close" className="clickable" onClick={hideBoostBanner} />
    </div>
  )
}
